// extracted by mini-css-extract-plugin
export default {"panel":"InsightsLayout_panel__cQKPt","statsRow":"InsightsLayout_statsRow__gVi+z","chartsGrid":"InsightsLayout_chartsGrid__FOOIl"};